export default {"src":"/_next/static/media/white-logo.2631ac47.svg","height":34,"width":30,"blurWidth":0,"blurHeight":0};